import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, CustomInput } from 'reactstrap'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { I18n } from 'react-redux-i18n'

import userAct from '../../redux/actions/user'
import Sockets, { SocketDash } from 'socket'

const HeaderDropdown = ({ dispatch, operator, history }) => {
  const userActions = bindActionCreators(userAct, dispatch)

  const [dropdownOpen, setDropdownOpen] = useState(false)

  useEffect(() => {
    Sockets.startAll()
    SocketDash.subscribe(operator.company)
    SocketDash.subscribe(operator._id)

    return () => {
      SocketDash.unsubscribe(operator._id)
      SocketDash.unsubscribe(operator.company)
      Sockets.destroyAll()
    }
  }, [operator.company, operator._id])

  const goTo = (route) => {
    const fullRoute = `/dashboard${route}`
    history.push(fullRoute)
  }

  return (
    <Dropdown nav isOpen={dropdownOpen} toggle={() => setDropdownOpen(!dropdownOpen)}>
      <DropdownToggle nav>
        <div
          className='mt-1 avatar'
          style={{ backgroundImage: `url(${operator.picture || 'img/default.png'})` }}
        >
          <div className={`operator_pointer-${operator.available ? 'available' : 'not_available'}`}/>
        </div>
      </DropdownToggle>
      <DropdownMenu right>
        <div className='header_operator-name'>
          {
            operator.name ? (
              <div><strong>{`${operator.name}`}</strong></div>
            ) : null
          }
          <div className='header_available-user'>
            <CustomInput
              type='switch'
              id='operator-logged-available'
              name='operator-logged-available'
              checked={operator.available}
              value={operator.available}
              onChange={() => dispatch(userAct.setAvailable(!operator.available))}
            />
            <label htmlFor='operator-logged-available'>
              {I18n.t('operator-logged-available')}
            </label>
          </div>
        </div>
        <DropdownItem onClick={() => goTo('/profile')}>
          <i className='fa fa-user' />
          {I18n.t('dashboard_my-account')}
        </DropdownItem>
        <DropdownItem onClick={() => userActions.logout()}>
          <i className='fa fa-sign-out' />
          {I18n.t('dashboard_logout')}
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  )
}

export default connect((state) => ({ operator: state.user }))(withRouter(HeaderDropdown))
